<div class="list-item row align-items-center">
  <div class="item-name col-lg-3 col-7">
    <a [routerLink]="['/prices', pair]" class="link row no-gutters align-items-center">
      <currency class="col-auto" [currency]="currency?.code"></currency>
      <div class="spacer col-auto"></div>
      <div class="info col">
        <div class="row">
          <div class="name col-lg-auto">{{currency?.name}}</div>
          <div class="code col-lg-auto">{{currency?.code}}</div>
        </div>
      </div>
    </a>
  </div><!-- .item-name -->
  <a class="item-data col-5 col-lg-4 align-items-center" [routerLink]="['/prices', pair]">
    <ng-container *ngIf="currency; else noData">
      <div class="row">
        <div class="d-flex flex-column item-price col-lg-6">
          <ng-container *ngIf="data?.defaultCurrency?.lastPrice else noValue">
            <div class="item-price">{{data?.defaultCurrency?.currency}} {{data?.defaultCurrency?.lastPrice || 0 | number:'0.2-2'}}</div>
            <div class="item-price text-sm text-gray" *ngIf="useGlobalCurrency">
              {{data?.baseCurrency?.currency}} {{data?.baseCurrency?.lastPrice || 0 | number:'0.2-6'}}
            </div>
          </ng-container>
        </div>
        <div class="item-change col-lg-6 d-flex align-items-center">
          <ng-container *ngIf="(data?.priceChangePercentage || data?.priceChangePercentage === 0) && !loading; else noValue">
            <div class="text-bold ltr" [ngClass]="data?.isPositvitePriceChange ? 'change-badge-primary' : 'change-badge-danger'">
              {{data?.isPositvitePriceChange ? '+': ''}}{{data?.priceChangePercentage || 0 | number:'0.2-2'}}%
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </a>
  <div class="col-lg-2 d-none d-lg-block">
    <div #chartElm></div>
  </div>
  <div class="col-lg-1 d-none d-lg-block"></div>
  <div class="col-lg-2 g-0 d-none d-lg-flex">
    <div class="col">
      <a [routerLink]="['/prices', pair]" class="col btn btn-outline btn-block"
        i18n="@@cryptoPrices.actions.details">Details</a>
    </div>
    <div class="p-1"></div>
    <div class="col">
      <a [routerLink]="['/lite', 'exchange', 'buy']" [queryParams]="{to: currency?.code, from: baseCurrencyCode}"
        class="col btn btn-primary btn-block" i18n="@@cryptoPrices.actions.trade">Buy</a>
    </div>
  </div>
</div><!-- .list-item -->

<ng-template #noValue>-</ng-template>

<ng-template #noData>
  <div class="item-data col-4 loading" i18n="@@cryptoPrices.row.loading">Loading ...</div>
</ng-template>
